// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width[data-v-55d7563e] {\n  max-width: 320px;\n}\n.disabled-box .address[data-v-55d7563e] {\n  margin-top: 10px;\n}\n.disabled-box .address[data-v-55d7563e] .el-textarea__inner {\n  padding-left: 8px;\n}\n.process-form .address[data-v-55d7563e] {\n  margin-top: 10px;\n  max-width: 320px;\n  display: block;\n}\n.process-form-show .address[data-v-55d7563e] {\n  margin-top: 3px;\n}\n.select-u[data-v-55d7563e] {\n  width: 100%;\n  max-width: 320px;\n}", ""]);
// Exports
module.exports = exports;
